import React from 'react';

const ExclaimIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.9974 6.66797V10.0013M9.9974 13.3346H10.0057M18.3307 10.0013C18.3307 14.6037 14.5998 18.3346 9.9974 18.3346C5.39502 18.3346 1.66406 14.6037 1.66406 10.0013C1.66406 5.39893 5.39502 1.66797 9.9974 1.66797C14.5998 1.66797 18.3307 5.39893 18.3307 10.0013Z'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default ExclaimIcon;
